import { DetermineTextColor } from "../utils/DetermineTextColor";
import { enumPanelDarkColors, kDarkYellow, kGreen, kSeaGreen, kYellow } from "../constants";
import { shadeColor } from "../utils/shadeColor";
import { Globals } from "./Globals";
import {
  uFramelessPanelColor,
  uFramelessPanelColorDarker,
  uFramelessPanelColorLighter
} from "../whitelabel/brand";

export class QUIColors {
  constructor() {}

  InDarkMode() {
    return Globals._themeMode === enumPanelDarkColors;
  }

  GetFontIconColor() {
    return Globals._themeMode.fonticon;
  }

  GetLightThemeColor() {
    return uFramelessPanelColorLighter;
  }

  GetThemeColor() {
    return uFramelessPanelColor;
  }

  GetDarkThemeColor() {
    return uFramelessPanelColorDarker;
  }

  GetThemeTextColor() {
    var themeColor = this.GetThemeColor();
    return DetermineTextColor(themeColor);
  }

  GetShadeThemeColor(shade) {
    var themeColor = this.GetThemeColor();
    return shadeColor(themeColor, shade);
  }

  // panel color methods
  GetPanelColors() {
    return Globals._themeMode.fill;
  }

  GetPrimaryPanelFillColor() {
    var panelColors = this.GetPanelColors();
    return panelColors.primary;
  }

  GetSecondaryPanelFillColor() {
    var panelColors = this.GetPanelColors();
    return panelColors.secondary;
  }

  GetAlternativePanelFillColor() {
    var panelColors = this.GetPanelColors();
    return panelColors.alt;
  }

  GetPadColor() {
    return Globals._themeMode.padcolor;
  }

  GetPanelBorderColor() {
    return Globals._themeMode.border;
  }

  GetViewPortColor() {
    return Globals._themeMode.viewportcolor;
  }

  GetLightPanelBorderColor() {
    return Globals._themeMode.lightborder;
  }

  // button color methods
  GetButtonColors() {
    return Globals._themeMode.button;
  }

  GetButtonFillColor() {
    var buttonColors = this.GetButtonColors();
    return buttonColors.fill;
  }

  GetButtonBorderColor() {
    var buttonColors = this.GetButtonColors();
    return buttonColors.border;
  }

  GetDisabledButtonColor() {
    var buttonColors = this.GetButtonColors();
    return buttonColors.disabled;
  }

  // text color methods
  GetTextColors() {
    return Globals._themeMode.text;
  }

  GetHeaderTextColor() {
    var textColors = this.GetTextColors();
    return textColors.header;
  }

  GetBodyTextColor() {
    var textColors = this.GetTextColors();
    return textColors.body;
  }

  GetDisabledTextColor() {
    var textColors = this.GetTextColors();
    return textColors.disabled;
  }

  GetTextSelectionColor() {
    var textColors = this.GetTextColors();
    return textColors.selection;
  }

  GetHoverTextColor() {
    var textColors = this.GetTextColors();
    return textColors.hover;
  }

  GetHighlightTextColor() {
    var textColors = this.GetTextColors();
    return textColors.highlight;
  }

  GetAlternativeTextColor() {
    var textColors = this.GetTextColors();
    return textColors.alt;
  }

  // text edit color methods
  GetTextEditColors() {
    return Globals._themeMode.textedit;
  }

  GetTextEditFillColor() {
    var textEditColors = this.GetTextEditColors();
    return textEditColors.fill;
  }

  GetTextEditBorderColor() {
    var textEditColors = this.GetTextEditColors();
    return textEditColors.border;
  }

  GetAlertTextColor() {
    return this.InDarkMode() ? "#F76F72" : "#B00020";
  }

  GetCautionTextColor() {
    return "#FFAB00";
  }

  GetWarningTextColor() {
    return this.InDarkMode() ? "#FFAB00" : "#A1683D";
  }

  GetSuccessTextColor() {
    return this.InDarkMode() ? kGreen : kSeaGreen;
  }

  GetFavoriteTextColor() {
    return this.InDarkMode() ? kYellow : kDarkYellow;
  }

  GetLinkTextBlueColor() {
    return this.InDarkMode() ? "#8AB4EB" : "#1A73E8";
  }

  GetPagingBlueColor() {
    return this.InDarkMode() ? "#3E7BFA" : "#3E7BFA";
  }
}
